import { render, staticRenderFns } from "./CongratulationPage.vue?vue&type=template&id=40823bc8&scoped=true&"
import script from "./CongratulationPage.vue?vue&type=script&lang=js&"
export * from "./CongratulationPage.vue?vue&type=script&lang=js&"
import style0 from "./CongratulationPage.vue?vue&type=style&index=0&id=40823bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40823bc8",
  null
  
)

export default component.exports